module.exports = __webpack_public_path__ + "images/home-dingtalk-work/howto_4-235b083ad093421d4127ebb462f13025.png";